import React from "react"

const Dot = () => {
  return (
  <span className="dot inline-flex bg-green"></span>
  )
}

export default Dot
